var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${
    _vm.type === 'flex' ? 'flex items-center justify-between flex-wrap gap-1' : ''
  } bg-white p-2 mb-0.5 rounded-md border border-grayNeutralLight`},[_c('div',{staticClass:"flex items-center gap-1"},[_vm._t("icon"),_c('div',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.label))])],2),_c('div',{class:`${_vm.type !== 'flex' ? 'mt-0.5' : 'font-medium'} text-grayNeutralDark`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }